import { ToastOptions } from 'ng2-toastr';

export let toastOptions: ToastOptions = new ToastOptions({
	positionClass: 'toast-bottom-right'
});